import {
  props,
  networkProps,
  networkErrors,
  networkLoading,
} from './utils'

const loaded = state => state.system.loaded

const NETWORK_NAMES = networkProps('system', [
  'initialize',
])

export default {
  loaded,
  errors: props(networkErrors, NETWORK_NAMES),
  loading: props(networkLoading, NETWORK_NAMES),
}
